<template>
  <v-select :items="items"
            v-model="apiSelected"
            class="input-group--focused"
            item-value="value"
            item-text="text"></v-select>
</template>

<script>
import store from '@/store';
import _ from 'lodash';

export default {
  name: 'apiSelect',
  watch: {
    apiSelected: function(newValue) {
      store.commit('CHANGE_API_SELECTED', newValue);
    }
  },
  data() {
    return {
      apiSelected: 'es',
      items: []
    };
  },
  created() {
    if (typeof store.state.apiSelected.code !== 'undefined') {
      this.apiSelected = store.state.apiSelected.code;
    }
    this.populateCountries();
  },
  methods: {
    populateCountries() {
      this.items = _.map(store.state.apiLocations, api => {
        return {
          value: api.code,
          text: api.name
        };
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/login/ApiSelect.vue